<template>
  <div>
    <b-modal
      v-model="isShowModal"
      size="md"
      :title="$t('editProductGP')"
      hide-footer
    >
      <div>
        <b-table-simple small caption-top responsive class="combination-table">
          <b-thead head-variant="light">
            <slot v-for="attr in attribute">
              <b-th>{{ attr.label }}</b-th>
            </slot>
            <b-th>GP (%)<span class="text-danger">*</span></b-th>
          </b-thead>
          <b-tbody>
            <slot v-for="(el, index) in form.productGP">
              <b-tr>
                <slot v-for="(option, oindex) in el.attribute">
                  <td :key="oindex" class="">
                    {{ option.option.label }}
                  </td>
                </slot>
                <b-td class="">
                  <b-form-input
                    :class="[
                      'input-children',
                      {
                        'combitable-error':
                          $v.form.productGP.$each.$iter[index].gp.$error,
                      },
                    ]"
                    v-model="el.gp"
                  ></b-form-input>
                </b-td>
              </b-tr>
            </slot>
          </b-tbody>
        </b-table-simple>
      </div>
      <b-row>
        <b-col>
          <span class="text-error" v-if="$v.$error == true">
            {{ $t("note") }}: {{ $t("minProductGP") }} {{ productGP }}%
          </span>
        </b-col>
      </b-row>
      <div class="w-100">
        <b-button variant="success" class="float-right ml-2" @click="checkForm">
          {{ $t("submitGP") }}
        </b-button>
        <b-button variant="secondary" class="float-right ml-2" @click="hide">
          {{ $t("cancelGP") }}
        </b-button>
      </div>
    </b-modal>
    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";

const validateMinGPConfig = (value, minGp) => {
  if (value < minGp) {
    return false;
  } else {
    return true;
  }
};

export default {
  components: {
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  props: {
    productGP: {
      required: false,
      type: Number,
    },
    productId: {
      required: false,
      type: Number,
    },
    attribute: {
      required: false,
      type: Array,
    },
    dataObject: {
      required: false,
      type: Object,
    },
    productConfigId: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      isShowModal: false,
      productGPList: [],
      children: [],
      childrenValidate: {},
      modalMessage: "",
      form: {
        productGP: [],
        lastUpdate: "",
      },
      index: -1,
    };
  },
  validations: {
    form: {
      productGP: {
        $each: {
          gp: {
            required,
            validateMinGPConfig(value) {
              return validateMinGPConfig(value, this.productGP);
            },
          },
        },
      },
    },
  },
  methods: {
    show() {
      this.isShowModal = true;
      this.children = JSON.parse(JSON.stringify(this.dataObject));

      this.getProductGPScheduleList();
    },
    hide() {
      this.isShowModal = false;
      this.$v.$reset();
    },
    checkForm() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      this.saveProductGPSchedule();
    },

    saveProductGPSchedule: async function () {
      this.$refs.modalLoading.show();
      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/product/ProductGP/save/${this.productId}`,
        null,
        this.$headers,
        this.form
      );

      this.modalMessage = resData.message;
      this.isDisable = false;
      this.$refs.modalLoading.hide();
      if (resData.result == 1) {
        this.$refs.modalAlert.show();
        setTimeout(() => {
          this.$refs.modalAlert.hide();
          this.hide();
          this.$emit("getData");
        }, 1000);
      } else {
        this.modalMessage = resData.detail[0];
        this.$refs.modalAlertError.show();
      }
    },
    getProductGPScheduleList: async function () {
      let data = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/product/ProductGP/List/${this.productId}`,
        null,
        this.$headers,
        null
      );

      if (data.result == 1) {
        this.index = data.detail.productGP.findIndex(
          (el) => el.productId == this.productConfigId
        );
        if (this.index > -1) {
          this.form.productGP = [data.detail.productGP[this.index]];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-children {
  width: 100%;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.combitable-error {
  border-color: red;
}
.combination-table.table thead th,
.table td {
  border: 1px solid #ebebeb;
}
// ::v-deep .modal-body {
//   height: 700px;
//   overflow: auto;
// }
</style>